import { render, staticRenderFns } from "./taxPage.vue?vue&type=template&id=69f9bcdc&scoped=true"
import script from "./taxPage.vue?vue&type=script&lang=js"
export * from "./taxPage.vue?vue&type=script&lang=js"
import style0 from "./taxPage.vue?vue&type=style&index=0&id=69f9bcdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f9bcdc",
  null
  
)

export default component.exports